export const maxLogoWidth = `560px`;
export const maxLogoHeight = `150px`;
// A width picked in the editor lowers the max width. The 560x150 box still applies, logos are stored resized
// to fit it, so going past it would pixelate. Outlook ignores max-width and takes the width attribute
export function generateLogo(logoUrl, align = 'center', pickedWidth) {
    if (!logoUrl)
        return '';
    const width = pickedWidth && Math.min(pickedWidth, parseInt(maxLogoWidth));
    const size = `max-width: ${width ? `${width}px` : maxLogoWidth}; max-height: ${maxLogoHeight}; width:auto;`;
    return /* html */ `
  <table class="wrapper" role="module" data-type="image" border="0" cellpadding="0"
    cellspacing="0" width="100%" style="table-layout: fixed;"
    data-muid="33d9da39-8bcb-42a0-b2ff-96bf7d6abdeb">
  <tbody>
    <tr>
      <td style="font-size:6px; line-height:10px; padding:0px 0px 0px 0px;" valign="top"
          align="${align}">
        <img border="0"${width ? ` width="${width}"` : ''}
              style="${size} display:block; color:#000000; text-decoration:none; font-family:Helvetica, arial, sans-serif; font-size:16px; height:auto;"
              alt="" data-proportionally-constrained="true" data-responsive="true"
              src="${logoUrl}">
      </td>
    </tr>
    </tbody>
  </table>
  `;
}
//# sourceMappingURL=generateLogo.js.map